import React, { createContext, useContext, useState, ReactNode } from 'react'
import { Snackbar, Alert, AlertColor } from '@mui/material'

interface ToastContextType {
    showToast: (message: string, severity?: AlertColor) => void
}

const ToastContext = createContext<ToastContextType | undefined>(undefined)

export const useToast = () => {
    const context = useContext(ToastContext)
    if (!context) {
        throw new Error('useToast must be used within ToastProvider')
    }
    return context
}

interface ToastProviderProps {
    children: ReactNode
    autoHideDurationInSeconds?: number
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ 
        children,
        autoHideDurationInSeconds,
    }) => {

    const [open, setOpen] = useState(false)
    const [message, setMessage] = useState('')
    const [severity, setSeverity] = useState<AlertColor>('info')

    const showToast = (msg: string, sev: AlertColor = 'info') => {
        setMessage(msg)
        setSeverity(sev)
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            <Snackbar
                open={open}
                autoHideDuration={autoHideDurationInSeconds ? autoHideDurationInSeconds * 1000 : 6000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        </ToastContext.Provider>
    )
}